
// Vue / Vuex
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { namespace } from 'vuex-class';

// Components
import vSelect from "vue-select";
import EventFilter from './EventFilter.vue';

// Types
import EventSearchModel from "@/types/eventSearch/EventSearchModel";
import { EventSearchState, DeviceType, AlarmType } from '@/store/event-search/types';

// Vuex Modules
const EventSearchStore = namespace("eventSearch");

@Component({
    components: {
        "event-filter": EventFilter,
        "v-select": vSelect,
    }
})
export default class DeviceTypeFilter extends Vue {
    @Prop({ default: null, type: Object, required: true }) value: EventSearchModel;

    @EventSearchStore.Action loadAlarmTypes!: (serviceTypeId: number) => Promise<void>;

    @EventSearchStore.Mutation setAlarmTypes!: (alarmTypes: AlarmType[]) => Promise<void>;

    @EventSearchStore.State((s: EventSearchState) => s.DeviceTypes) deviceTypes: DeviceType[];

    /**
     * @summary setter to set the deviceTypeId by deviceType
     */
    private set deviceType(value: DeviceType) {
        if (!value) {
            this.value.deviceType = null;
            return;
        }
        this.value.deviceType = value.serverTypeID;
    }

    /**
     * @summary computed property to get the deviceType by deviceId
     */
    private get deviceType() {
        return this.deviceTypes.find((x) => x.serverTypeID === this.value?.deviceType) ?? null;
    }

    /**
     * @summary Watcher to set or reset the alarm types
     * depending on the device type given.
     */
	@Watch("value.deviceType")
	public onDeviceTypeChange(value: number) {
		// Alarm types depend on selected deviceType
		if (value) {
			this.loadAlarmTypes(value);
		} else {
			this.setAlarmTypes([]);
		}
	}
}
